
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.347.002c-2.439.002-4.8.865-6.672 2.44a10.523 10.523 0 00-3.578 6.175A8.963 8.963 0 005.91 11.54a9.048 9.048 0 00-1.46 4.087 7.456 7.456 0 00-2.834 2.203 7.558 7.558 0 00-1.282 6.883 7.515 7.515 0 001.849 3.089 7.438 7.438 0 003.066 1.863 7.396 7.396 0 006.832-1.292 7.497 7.497 0 002.187-2.856 8.896 8.896 0 004.048-1.45 8.98 8.98 0 002.909-3.188 10.413 10.413 0 006.581-3.926 10.561 10.561 0 00-1.283-14.28 10.383 10.383 0 00-7.175-2.67zm-7.449 23.159c0 .15 0 .3-.104.465a4.512 4.512 0 01-1.137 2.05A4.462 4.462 0 018.65 26.87a4.436 4.436 0 01-2.33.014 4.461 4.461 0 01-2.021-1.17 4.535 4.535 0 01-1.147-4.384 4.51 4.51 0 011.185-2.022 4.46 4.46 0 012.034-1.145l.417-.15a4.349 4.349 0 013.902 1.217 4.444 4.444 0 011.208 3.93zm7.449-5.508c-.02.096-.045.191-.075.285a6.005 6.005 0 01-1.838 3.095 5.946 5.946 0 01-2.437 1.317c0-.27 0-.525-.09-.795s0-.405 0-.6c0-.195-.178-.57-.268-.856-.09-.285-.104-.36-.179-.54a6.332 6.332 0 00-.447-.826c0-.135-.134-.285-.223-.42a7.949 7.949 0 00-.894-1.096l-.298-.255a8.225 8.225 0 00-.79-.645 4.314 4.314 0 00-.506-.285 5.948 5.948 0 00-.745-.405 3.47 3.47 0 00-.596-.196 4.638 4.638 0 00-.774-.24c-.209 0-.432 0-.656-.09l-.908-.09c.237-.909.682-1.75 1.3-2.453a5.96 5.96 0 012.26-1.6c.255-.107.52-.192.79-.254l.297-.075a5.536 5.536 0 011.118-.12c1.58 0 3.096.632 4.213 1.758a6.026 6.026 0 011.746 4.245 5.812 5.812 0 01-.12 1.14h.12zm2.98-.24v-.901a9.04 9.04 0 00-2.619-6.368 8.905 8.905 0 00-6.32-2.637h-.894a7.498 7.498 0 012.192-2.843 7.395 7.395 0 016.822-1.276 7.44 7.44 0 013.06 1.86 7.515 7.515 0 011.846 3.083 7.558 7.558 0 01-1.266 6.873 7.456 7.456 0 01-2.822 2.209z"}})])
          )
        }
      }
    